import {setEffectParameterValues} from 'actions/index.js';

export default superclass => class extends superclass  {

    // 1/16th steps to state mapping
    stepToState = {};
    sequencerEnabled = true;
    stepSelected = undefined;

    deleteStateAtStep(step) {
        delete this.stepToState[step];
        // since we've deleted lets go back to the initial values
        this.effect.resetValues();
    }

    selectStep(step) {
        let bulk = this.applySequencedState(this.stepToState[step], undefined, 0.001);
        this.stepSelected = step;
        if (!bulk) {
            return;
        }
        this.track.sequencerEngine.dispatch(
            setEffectParameterValues(bulk));
    }

    unselectStep() {
        this.stepSelected = undefined;
    }

    recordStateAtStep(step) {
        let parameterCoords = {};
        this._parameters.forEach(
            p => parameterCoords[p.id] = p.getCoordinates());
        this.stepToState[step] = parameterCoords;
        this.stepSelected = undefined;
    }

    sequenceStep(step, time, rampTime) {
        if (!this.sequencerEnabled) {
            return false;
        }
        // step is in 1/32th so we need to convert to 1/16th
        step = Math.floor(step/2);

        let state = this.stepToState[step];
        return this.applySequencedState(state, time, rampTime);
   }

    applySequencedState(state, time, rampTime) {
        if (!state) {
            // we have nothing sequenced here
            return undefined;
        }

        let bulk = {};
        for (let _id in state) {
            let parameter = this._parameters.find(
                p => p.id === _id);
            if (!parameter) {
                continue;
            }
            let {id, value} = parameter.setCoordinates(
                state[_id].x, state[_id].y,
                time,
                rampTime / 1000.0,
                true);
            bulk[_id] = value;
        }
        return bulk;
    }
}
